import { cn } from '../utils';

/**
 * Skeleton — base loading placeholder element.
 *
 * Canonical shadcn/ui primitive. Use as a low-level building block for
 * higher-level skeleton patterns (cards, tables, lists).
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
